import { isNumber } from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import { DoubleEliminationGroup } from '../enums';

const DEFAULT_LOWER_ROUND_DELAY = 5;

export const useRoundBreakDelay = (round?: number, group?: number) => {
  const breakDuration: number = useSelector(currentTournamentSelector.breakDuration);

  const gameBreakDuration = useMemo(() => {
    if (!breakDuration) {
      return 0;
    }

    if (group === DoubleEliminationGroup.Lower) {
      let delay: number;
      if (!isNumber(round)) {
        delay = DEFAULT_LOWER_ROUND_DELAY;
      } else {
        delay = round % 2 ? DEFAULT_LOWER_ROUND_DELAY : DEFAULT_LOWER_ROUND_DELAY + 2;
      }

      return breakDuration * 60 + delay;
    }

    return breakDuration * 60;
  }, [breakDuration, group, round]);

  return { gameBreakDuration };
};
